import React, { useState, useRef, useEffect } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import styles from './CreateNews.module.scss';
import CreateNewsHeader from '../../../Molecules/NewsAndEvents/CreateNewsHeader';
import folderIcon from '../../../../assets/Imagess/folderICon.svg';
import uploadIcon from '../../../../assets/Imagess/upload-icon.svg';
import DatePicker from 'react-datepicker';
import { useMutation } from 'react-query';
import axios from 'axios';
import {
  API_URL,
  quillFormats,
  quillModules,
  securityHeaders,
} from '../../../../Constants';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';
import { useFetchNewsletterById } from '../../../../Hooks/Newsletters';
import newsletterUpdated from '../../../../assets/Imagess/newsletter-updated.png';
import { isEmpty, values } from 'lodash';
import './Quill.css';
import 'react-quill/dist/quill.snow.css';
import { toast } from 'react-toastify';
import noImageFound from '../../../../assets/Imagess/no-image-found.jpg';
import TextInput from '../../../Atoms/Inputs/TextInput';
import { useToast } from '../../../Molecules/Custom/CustomToaster/Toast';
import Loader from '../../../Molecules/Loader/Loader';
import { sanitizeAndValidateUrl } from '../../../../app/helpers/sanitizeAndValidateUrl';
import TextEditor from '../../../Molecules/Email/TextEditor';
import DateInput from '../../../Atoms/Inputs/DateInput';

const UpdateNewsletter = () => {
  const fileInputRef = useRef(null);
  const customizedToast = useToast();
  const navigate = useNavigate();
  const [imageSrc, setImageSrc] = useState('');
  const params = useParams();
  const { id } = params;
  const [showCheckmark, setShowCheckmark] = useState(false);
  const {
    data: newsletter,
    isLoading,
    refetch: refetchNewsletter,
  } = useFetchNewsletterById({ id });
  const formikRef = useRef(null);

  const calendarIcon = (
    <svg
      width='22'
      height='22'
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='Group 20956'>
        <path
          id='Vector'
          d='M5.43428 0C5.89173 0 6.26256 0.356629 6.26256 0.79655V2.40335C6.99725 2.38964 7.82078 2.38964 8.74737 2.38964H13.1648C14.0914 2.38964 14.9149 2.38964 15.6496 2.40335V0.79655C15.6496 0.356629 16.0204 0 16.4779 0C16.9353 0 17.3062 0.356629 17.3062 0.79655V2.47382C18.8957 2.59623 19.9393 2.89665 20.7059 3.63393C21.4726 4.37121 21.785 5.37475 21.9122 6.90341L21.9999 7.69996H1.01701H0V6.90341C0.12728 5.37475 0.439668 4.37121 1.20631 3.63393C1.97296 2.89665 3.01647 2.59623 4.60601 2.47382V0.79655C4.60601 0.356629 4.97684 0 5.43428 0Z'
          fill='#A9A7A7'
        />
        <path
          id='Vector_2'
          d='M22 14.0001V12.0001C22 11.161 21.9965 9.66526 21.9823 9H0.0110106C-0.00319018 9.66526 0.000406649 11.161 0.000406649 12.0001V14.0001C0.000406649 17.7712 0.000406628 19.6568 1.28911 20.8284C2.57782 22 4.65196 22 8.80026 22H13.2002C17.3485 22 19.4226 22 20.7114 20.8284C22 19.6568 22 17.7712 22 14.0001Z'
          fill='#A9A7A7'
        />
      </g>
    </svg>
  );

  useEffect(() => {
    if (!isEmpty(id) && id !== undefined) {
      refetchNewsletter();
    }
  }, [id]);

  useEffect(() => {
    if (!isEmpty(newsletter)) {
      const newsletterData = newsletter.data;
      formikRef.current.setValues({
        nameAr: newsletterData.title_AR || '',
        newsletterDate: newsletterData.newsletterDate
          ? new Date(newsletterData.newsletterDate)
          : '',
        textAr: newsletterData.body_AR || '',
      });
      setImageSrc(
        sanitizeAndValidateUrl(
          `${newsletter?.data?.url}${newsletter?.data?.newsletterImage}`
        )
      );
    }
  }, [newsletter]);

  const validationSchema = Yup.object().shape({
    nameAr: Yup.string().required('Arabic newsletter event name is required'),
    newsletterDate: Yup.date().required('Newsletter date is required'),
    image: Yup.mixed().test(
      'image-required',
      'الصورة مطلوبة',
      function (value) {
        const hasNewFile = value instanceof File;
        const hasExisting = !!imageSrc;
        return hasNewFile || hasExisting;
      }
    ),
    textAr: Yup.string().required('مطلوب تعبئته'),
  });

  const createNewsletter = useMutation({
    mutationFn: (fields) => {
      return axios.post(API_URL + `/api/News/Newsletter`, fields, {
        headers: securityHeaders,
      });
    },

    onSuccess: () => {
      customizedToast.open(
        id
          ? 'تم تحديث النشرة الإخبارية بنجاح'
          : 'تم إنشاء النشرة الإخبارية بنجاح'
      );
      setTimeout(() => {
        formikRef.current.resetForm();
        navigate(-1);
      }, 2000);
    },
    onError: (error) => {
      toast.error(error?.message);
    },
  });

  const handleSubmit = (values) => {
    var formData = new FormData();
    formData.append('Title_AR', values.nameAr);
    if (undefined !== values.image) {
      formData.append('NewsletterImage', values.image);
    }
    formData.append(
      'NewsletterDate',
      moment(values.newsletterDate).format('YYYY-MM-DD')
    );
    const newsletterId = id ? id : '00000000-0000-0000-0000-000000000000';
    formData.append('NewsletterId', newsletterId);
    formData.append('Body_AR', values.textAr);
    createNewsletter.mutate(formData);
  };

  const triggerFormSubmission = () => {
    formikRef.current.submitForm();
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className={styles['action-programs']}>
      <div className={styles['container']}>
        <CreateNewsHeader
          handleSubmit={triggerFormSubmission}
          title={!isEmpty(id) ? 'تعديل منشورة' : 'إنشاء منشورة'}
        />
      </div>
      <div className={styles['container']} style={{ paddingTop: '0px' }}>
        <Formik
          innerRef={formikRef}
          initialValues={{
            nameAr: newsletter?.data?.title_AR || '',
            newsletterDate: newsletter?.data?.newsletterData
              ? new Date(newsletter?.data?.newsletterData)
              : '',
            textAr: newsletter?.data?.body_AR || '',
            image: undefined,
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, errors, touched }) => (
            <Form>
              <div className={styles['newsletter-steps']}>
                <div
                  className={` ${styles['rtl']}`}
                  style={{ display: 'block' }}
                >
                  <TextInput
                    label='عنوان المنشورة'
                    placeholder='أدخل العنوان'
                    icon={folderIcon}
                    style={{
                      width: '100%',
                      justifyContent: 'flex-start',
                      marginBottom: '26px',
                    }}
                    containerStyle={{ padding: '0px' }}
                    name='nameAr'
                    value={values.nameAr}
                    errors={errors.nameAr}
                    touched={touched.nameAr}
                    onChange={(name, value) => setFieldValue(name, value)}
                  />
                </div>
                <DateInput
                  label='التاريخ' // "Date"
                  placeholder='اختر التاريخ' // "Select Date"
                  showIcon
                  value={values.newsletterDate}
                  name='newsletterDate'
                  onChange={setFieldValue}
                  showTimeSelect={true}
                  dateFormat='yyyy-MM-dd'
                  timeFormat='HH:mm'
                  timeInputLabel='الوقت:' // "Time:"
                  errors={errors.newsletterDate}
                  touched={touched.newsletterDate}
                />
              </div>
              <div>
                <div className={`${styles['quill-container']}`}>
                  <TextEditor
                    label='تفاصيل المنشورة'
                    value={values.textAr}
                    onChange={(name, value) => {
                      setFieldValue(name, value);
                    }}
                    modules={quillModules}
                    formats={quillFormats}
                    name='textAr'
                    placeholder='ادخل الوصف'
                    errors={errors.textAr}
                    touched={touched.textAr}
                    right
                  />
                </div>
              </div>
              <div style={{ marginTop: '30px' }}>
                <label> اختر صورة للتحميل</label>
              </div>
              {errors.image && (
                <div className={styles['error-message']}>
                  <p>{errors.image}</p>
                </div>
              )}
              <div
                className={styles['upload-container']}
                onClick={() => {
                  if (fileInputRef.current) fileInputRef.current.value = '';
                  fileInputRef.current.click();
                }}
              >
                <input
                  type='file'
                  className='form-control form-body-input'
                  accept='image/*'
                  style={{ display: 'none' }}
                  ref={fileInputRef}
                  onChange={(event) => {
                    setFieldValue('image', event.currentTarget.files[0]);
                  }}
                />
                {values.image || imageSrc ? (
                  <div className={styles['image-container']}>
                    <img
                      className={styles['uploaded-image']}
                      src={
                        values.image
                          ? URL.createObjectURL(values.image)
                          : imageSrc
                      }
                      alt='صورة مختارة'
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = noImageFound;
                      }}
                    />
                    <button
                      className='delete-button-images'
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setFieldValue('image', null);
                        setImageSrc('');
                      }}
                      title='حذف الصورة'
                      type='button'
                    >
                      ✕
                    </button>
                  </div>
                ) : (
                  <div className={styles['upload-icon-container']}>
                    <img
                      className={styles['upload-icon']}
                      src={uploadIcon}
                      alt='تحميل' // "Upload"
                    />
                    <div className={styles['text-container']}>
                      <p className={styles['select-image']}>
                        اختر صورة للتحميل
                      </p>
                      <p className={styles['size']}>
                        {' '}
                        الحد الأقصى للحجم: <span dir='ltr'>100 MB</span>{' '}
                      </p>
                    </div>
                    <p className='select-sizes'>
                      حجم الصورة: العرض: 1252px الارتفاع: 270px
                    </p>
                  </div>
                )}
              </div>

              <button
                type='submit'
                className={styles['submit-button']}
                style={{ display: 'none' }}
              >
                Submit
              </button>
            </Form>
          )}
        </Formik>
      </div>
      {showCheckmark && (
        <div className={styles['checkmark']}>
          <img src={newsletterUpdated} />
        </div>
      )}
    </div>
  );
};

export default UpdateNewsletter;
